import React from 'react';
import './ExcelDownloadButton.scss';
import { Button } from '@mui/material';
import excelIconBlue from '../../assets/excelIconBlue.png';
import { downloadTableAsExcel } from '../../utils/triggerDownload';

const ExcelDownloadButton = ({ garageName, formattedDate, report }) => {
  const isSmallScreen = window.innerWidth < 770;

  const handleClick = () => {
    downloadTableAsExcel(
      'table-to-xls',
      'tablexls',
      `${garageName}_${report}_${formattedDate}`
    );
  };

  return (
    <button
      type="button"
      className="xlsButton"
      id="test-table-xls-button"
      onClick={handleClick}
    >
      <div className="buttonWrapper">
        {isSmallScreen ? (
          <img src={excelIconBlue} alt="Excel Icon" />
        ) : (
          <Button component="span" variant="contained" color="primary">
            Download as Excel
          </Button>
        )}
      </div>
    </button>
  );
};

export default ExcelDownloadButton;
